/**
 * Copy, routes and validation messages for the redesigned auth screens
 * (`LoginNew`, `ForgotPasswordNew`, `PasswordResetNew`). Kept separate from the
 * components so copy changes don't touch behaviour, and vice versa.
 */

export const AUTH_ROUTES = {
  login: "/auth",
  forgotPassword: "/password-forgot",
  resetPassword: "/password-reset"
} as const;

export const AUTH_COPY = {
  login: {
    eyebrow: "Secure access",
    title: "Sign in",
    subtitle: "Welcome back to your workspace.",
    submitLabel: "Sign in"
  },
  forgotPassword: {
    eyebrow: "Account recovery",
    title: "Forgot password",
    subtitle: "Get a temporary password for your account.",
    submitLabel: "Send temporary password"
  },
  resetPassword: {
    eyebrow: "Account security",
    title: "Reset password",
    subtitle: "A fresh password for your workspace.",
    submitLabel: "Reset password"
  }
} as const;

export const VALIDATION_MESSAGES = {
  emailRequired: "Please enter email",
  emailInvalid: "Please enter the valid email",
  passwordRequired: "Please enter password",
  oldPasswordRequired: "Please enter old password",
  newPasswordRequired: "Please enter new password",
  confirmPasswordRequired: "Please confirm your new password",
  confirmPasswordMismatch: "Passwords do not match",
  termsRequired: "Please agree to terms and conditions"
} as const;

export const FIELD_MAX_LENGTH = {
  email: 255,
  password: 128
} as const;
